module.exports = "<app-marqetmap-app></app-marqetmap-app>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main